import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import moment from "moment/moment";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import MachineStatusFilter from "./MachineStatusFilter";

const columns = [
    {
        accessor: "machine_name",
        header: "Machine Name",
        cell: (row) => <>{row?.machine?.machine_name}</>,
    },
    {
        accessor: "machine_status",
        header: "Machine Status",
        filterable: true,
        filterType: "dropdown",
        filterOpt: [
            { value: "up", label: "up" },
            { value: "down", label: "down" },
        ],
    },
    {
        accessor: "status_time",
        header: "Status Time",
        cell: (row) => (
            <>{moment(row?.status_time).format("DD-MM-YYYY HH:MM:SS")}</>
        ),
    },
];

const MachineDetailedStatus = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const location = useLocation();
    const [machineStatusEntries, setMachineStatusEntries] = useState(10);
    const [machineStatusPageIndex, setMachineStatusPageIndex] = useState(0);
    const [search, setSearch] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [dateFilter, setDateFilter] = useState("");

    console.log(location.state);

    const { useFetch } = useAPIQuery({
        key: "machine_status",
        endpoint: "/api/machine_status/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: machineStatusEntries,
            page_no: machineStatusPageIndex + 1,
            q:
                globalFilterValue !== ""
                    ? globalFilterValue
                    : columnFilterValue !== ""
                    ? columnFilterValue +
                      `,${location.state?.data?.machine?.id}`
                    : `${location.state?.data?.machine?.id}`,
            c:
                globalFilterValue !== ""
                    ? ""
                    : columnFilterKey !== ""
                    ? columnFilterKey + ",machine"
                    : "machine",
            date: dateFilter,
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };

    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setMachineStatusPageIndex(value.pageIndex);
        setMachineStatusEntries(value.pageSize);
    };
    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Machine Status
                        </h3>
                    </div>
                    <div className="d-flex align-items-center justify-content-center ms-auto">
                        <button
                            className="btn btn-icon btn btn-outline-primary rounded-pill me-3"
                            data-bs-toggle="modal"
                            data-bs-target="#date-filter-modal"
                        >
                            <em className="icon ni ni-filter-fill" />
                        </button>
                    </div>
                </div>
            </div>

            <Table
                data={data ? data?.results.data : []}
                columns={columns}
                pagination
                pageIndex={machineStatusPageIndex}
                pageSize={machineStatusEntries}
                rowCount={data ? data.count : 0}
                globalSearch={false}
                isLoading={isLoading || isFetching}
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
            />
            <MachineStatusFilter setFilter={setDateFilter} />
        </>
    );
};

export default MachineDetailedStatus;
